import { Message, Loading } from 'element-ui'
import axios from '@/utils/request'

export default {
  install (Vue) {
    // 表格居中
    Vue.prototype.tableCenter = function () {
      return 'text-align: center;'
    }
    // 表头
    Vue.prototype.tableHeaderCenter = function () {
      return `
            text-align: center;
            font-size: 14px;
            font-weight:500;
            color: #333;
            background: #fafcff;
        `
    }
  }
}

/**
 *
 */
export function filterEmpyKey (data) {
  const obj = {}
  Object.keys(data).forEach(item => {
    if (data[item] !== null && data[item] !== '' && typeof (data[item]) !== 'undefined' && !obj[item]) {
      obj[item] = data[item]
    }
  })
  return obj
}

export function exportFiles (api, searchForm, fileName = '') {
  const loading = Loading.service({
    lock: true,
    text: '正在导出...',
    background: 'rgba(0, 0, 0, 0.8)'
  })
  return axios.post(api, filterEmpyKey(searchForm), {
    responseType: 'blob'
  }).then(res => {
    const contentDisposition = res.headers['content-disposition']
    let fName = fileName || '导出'
    if (contentDisposition) {
      fName = contentDisposition
        .substring(contentDisposition.indexOf('filename'))
        .split('=')[1]
    }
    const blob = new Blob([res.data])
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    downloadElement.download = decodeURIComponent(fName) // 下载后文件名
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href)
  }).catch(e => {
    // 保留后端返回的登录、权限或业务原因，避免被通用导出提示覆盖。
    Message({ type: 'error', message: e.message || '导出异常，请重试' })
  }).finally(() => {
    loading.close()
  })
}

export function uploadValidate (file) {
  console.log(file)
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)
  if (!['jpg', 'png', 'jpeg', 'gif', 'txt', 'mp4', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'rar', 'pdf', 'mp3', 'zip'].includes(suffix)) {
    Message.warning('请上传jpg/png/jpeg/gif/txt/mp4/mp3/doc/docx/xls/xlsx/ppt/pptx/rar/pdf/zip格式的文件')
    return false
  } else {
    return true
  }
}

export function uploadValidateImg (file) {
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)
  if (!['jpg', 'png', 'jpeg', 'gif'].includes(suffix)) {
    Message.warning('请上传jpg/png/jpeg/gif格式的图片')
    return false
  } else {
    return true
  }
}

export function uploadValidateVideo (file) {
  const size = (file.size / 1024 / 1024) < 300
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)

  if (!['mp4', 'flv'].includes(suffix) || !size) {
    Message.warning('只能上传mp4/flv文件，且不超过300M')
    return false
  } else {
    return true
  }
}

export function downloadExcelFile (data, fileName) {
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const downloadElement = document.createElement('a')
  // 创建下载的链接
  const href = window.URL.createObjectURL(blob)
  downloadElement.href = href
  // 下载后文件名
  downloadElement.download = decodeURIComponent(fileName)
  document.body.appendChild(downloadElement)
  downloadElement.click()
  document.body.removeChild(downloadElement)
  // 释放掉blob对象
  window.URL.revokeObjectURL(href)
}
